import { render } from "./Order.vue?vue&type=template&id=02a472da&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=02a472da&lang=less&scoped=true"
import "./Order.vue?vue&type=style&index=1&id=02a472da&lang=less"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a472da"]])

export default __exports__